import Vue from 'vue';
import sessionStorageKeys from '@/consts/sessionStorageKeys';
import storageKeys from '@/consts/storageKeys'

export default class {
    constructor(store, router) {
        this.$store = store

        router.beforeEach((to, from, next) => {
            if (to.meta.auth && !store.state.user) {
                this.loginFromStorage().then(() => {
                    next()
                }, () => {
                    next('/auth')
                })
            } else {
                next()
            }
        })
    }
    async login(data) {
        const token = btoa(unescape(encodeURIComponent(data.login + ':' + data.password)))
        const storageToken = btoa(unescape(encodeURIComponent(data.login + '㋛' + data.password)))

        const user = {
            site: {
                name: data.site,
                id: Date.now()
            },
            login: data.login,
            remember: data.remember,
        }

        addNewUserInUsers(user,storageToken)
        addNewSiteInSiteHistory(user.site)

        this.$store.commit('setUser', user)

        Vue.http.headers.common['Authorization'] = 'Basic ' + token

        try {
            await this.$store.dispatch('getCams')
        } catch (e) {
            if (e.status === 400) {
                this.$store.commit('resetUser')
            }
            throw e
        }

        try {
            await this.$store.dispatch('setWsWebConnect')
        } catch (e) {
            this.$store.commit('resetUser')
            throw e
        }
    }

    loginFromStorage() {
        return new Promise((resolve, reject) => {
            const user = this.getUserFromStorage();

            if (user) {
                this.login(user).then(() => {
                    resolve()
                }, () => {
                    reject()
                })
            } else
                reject()
        })
    }

    getTokenFromStorage(token) {
        return decodeURIComponent(escape(atob(token))).split('㋛')
    }

    getUserFromStorage() {
        const usersJson = localStorage.getItem(storageKeys.USERS)
        const token = localStorage.getItem(storageKeys.USER_TOKEN)

        if (!(usersJson && token)) {
            return
        }

        const users = JSON.parse(usersJson)
        const data = this.getTokenFromStorage(token);

        if (data.length !== 2) {
            return
        }

        const login = data[0]
        const user = users.find(item => {
            return item.login = login
        })

        if (!user) {
            return
        }

        return { site: user.site.name, login: login, password: data[1], remember: user.remember }


    }

    logout() {
        localStorage.removeItem(storageKeys.USER_TOKEN)
        sessionStorage.removeItem(sessionStorageKeys.STREAM_MODE)
        sessionStorage.removeItem(sessionStorageKeys.STREAM_QUALITY)
        sessionStorage.removeItem(sessionStorageKeys.SHOW_ALARMED_CAMS)

        this.$store.commit('resetUser')

        return new Promise((resolve, reject) => {
            resolve()
        });
    }
}


const addNewUserInUsers = (user,storageToken) => {
    const usersInLocalStorage = localStorage.getItem(storageKeys.USERS)
    const users = usersInLocalStorage ? JSON.parse(usersInLocalStorage) : [];

    const userIndexInUsers = users.findIndex((userInUsers) => userInUsers.login === user.login);

    if (userIndexInUsers > -1) {
        users.splice(userIndexInUsers, 1);
    }

    users.unshift(user)

    localStorage.setItem(storageKeys.USERS, JSON.stringify(users))
    localStorage.setItem(storageKeys.USER_TOKEN, storageToken)
}

const addNewSiteInSiteHistory = (newSite) => {
    const siteHistoryJSON = localStorage.getItem(storageKeys.SITE_HISTORY);
    const siteHistory = siteHistoryJSON ? JSON.parse(siteHistoryJSON) : []

    if (siteHistory.length > 0) {
        const currentSiteNameIndex = siteHistory.findIndex((siteInHistory) => siteInHistory.name === newSite.name)

        if (currentSiteNameIndex > -1) {
            siteHistory.splice(currentSiteNameIndex, 1)
        }
    }

    siteHistory.unshift(newSite)

    localStorage.setItem(storageKeys.SITE_HISTORY, JSON.stringify(siteHistory))
}


// WEBPACK FOOTER //
// ./src/services/AuthService.js